// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getPerformance, trace } from "firebase/performance";

const firebaseConfig = {
  apiKey: "AIzaSyBZYbU0EIaUJyyDaQ0axTZkeyfpQUJY4b8",
  authDomain: "taxapp-e8282.firebaseapp.com",
  projectId: "taxapp-e8282",
  storageBucket: "taxapp-e8282.firebasestorage.app",
  messagingSenderId: "1064177890466",
  appId: "1:1064177890466:web:085dc1fec9fb3c9d75d3fb",
  measurementId: "G-1628597CZF"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

let performanceInstance;

function getPerformanceInstance() {
  if (typeof window === "undefined") return null;
  if (performanceInstance !== undefined) return performanceInstance;

  try {
    performanceInstance = getPerformance(app);
  } catch (error) {
    console.warn("Firebase Performance Monitoring is not available in this browser:", error);
    performanceInstance = null;
  }
  return performanceInstance;
}

function cleanTraceName(name) {
  return String(name || "app_trace")
    .replace(/[^A-Za-z0-9_]/g, "_")
    .slice(0, 100);
}

export async function startPerformanceTrace(name, attributes = {}) {
  const perf = getPerformanceInstance();
  if (!perf) return null;

  const activeTrace = trace(perf, cleanTraceName(name));
  Object.entries(attributes).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    activeTrace.putAttribute(cleanTraceName(key).slice(0, 32), String(value).slice(0, 100));
  });
  activeTrace.start();
  return activeTrace;
}
